import Container from '@framework/di/Container';
import CreditFlowResearchRepository from '@/creditflowresearch/infrastructure/repository/CreditFlowResearchRepository';
import { ISingleStatWithData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stat';
import { formatAttachment } from '@/creditflowresearch/application/ArticlesAndStats/helpers';

export const fetchStatById = async (statId: number, container: Container): Promise<ISingleStatWithData> => {
  const statRepository = container.get<CreditFlowResearchRepository>(CreditFlowResearchRepository);
  const stat = await statRepository.getStatByViewId(Number(statId));
  const categories = await statRepository.getMarketCategoriesList({
    filters: { includedCategoryIds: stat.categories },
  });
  return {
    ...stat,
    attachment: stat.attachment ? [formatAttachment(stat.attachment)] : [],
    categories,
  };
};
